import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { RenderTimePicker } from './RenderTimePicker';

const selector = formValueSelector('generateForm');

const mapStateToProps = state => ({
  date: selector(state, 'date')
});

export const RenderTimePickerContainer = connect(
  mapStateToProps,
  null
)(RenderTimePicker);
